import React, { Component } from 'react';
import RevisionReportsLayout from '../../templates/revision_reports';
import Loading from "./../../elements/loading";
import ReportsFinancialEditForm from '../../elements/revision/reports_financial';

class RevisionReportsFinancial extends Component{
	render (){
		let { revision} = this.props;
		return (
			revision.isFetching ? <Loading/>:<ReportsFinancialEditForm {...this.props}/>
		)
	}

	componentWillMount() {
		let { modality, state, municipality } = this.props.match.params;

		this.props.reset('reports');
		this.props.fetchRevisionReports('project-report-goals',modality, state, municipality);
	}

	componentWillReceiveProps(newprops) {
		let { modality, state, municipality } = newprops.match.params;

		if(newprops.match.params !== this.props.match.params) {

			this.props.reset('revision.reports.financial.agency');
			this.props.fetchRevisionReports('project-report-goals',modality, state, municipality);
		}
	}
}

export default RevisionReportsLayout(RevisionReportsFinancial, {subnav: 1});


// WEBPACK FOOTER //
// ./src/layouts/revision/reports_financial.jsx